import { render } from "./question.vue?vue&type=template&id=38b29220&scoped=true"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=38b29220&scoped=true&lang=scss"
import "./question.vue?vue&type=style&index=1&id=38b29220&scoped=true&lang=scss"

import exportComponent from "/root/workspace/youyi_1_tob-teacher-fe_Ff2X/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b29220"]])

export default __exports__